import { MenuItem, NavDropdown } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Process } from "../../icons/Process";
import CONFIGURATION from "../../configuration";
import { trackingShape, withConfiguration, withTracking } from "../../context";
import { locationShape } from "../../shapes";
import { sentryUnmask } from "../../utils/sentryUtils";

type Props = {
  readonly location: locationShape;
  readonly configuration?: {
    readonly appName?: string;
    readonly applications?: $TSFixMe;
    readonly hiddenApplications?: string[];
  };
  readonly tracking?: trackingShape;
};

export function NavigationAppSwitcher({
  configuration = {},
  location,
  tracking,
}: Props) {
  const { applications = {} } = configuration;
  const switcherTracking = (applicationKey: string) => {
    tracking?.trackEvent(`AppSwitcher-${applicationKey}-click`);
  };

  const applicationItems = Object.keys(applications)
    .filter((appName) => !configuration?.hiddenApplications?.includes(appName))
    .map((appName) => {
      const url = () => {
        if (configuration.appName === "netilion")
          return `${applications[appName]}`;
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        return `${applications[appName]}/redirect${location.pathname.substring(CONFIGURATION.BASE_URL.length)}`;
      };
      const appIcon = (() => {
        switch (appName) {
          case "fermentation":
            return "icon3 icon3-eh-netilion-fermentation";
          case "liquiline_assist":
            return "icon3 icon3-eh-netilion-liquiline-assist";
          default:
            return `icon lcm-iot-icon-${appName}`;
        }
      })();

      // EH Font icons are deprecated and brand team advised to use SVG icons instead.
      return (
        <MenuItem
          id={`${appName}-item`}
          key={appName}
          className={sentryUnmask("menu-item")}
          href={url()}
          onClick={() => switcherTracking(appName)}
        >
          <div className="menu-app-icon">
            {appName === "process" ? (
              <div className="svg-icon-container">
                <Process className="svg-icon" />
              </div>
            ) : (
              <span className={appIcon} />
            )}
          </div>
          <span className="title">
            <FormattedMessage id={`app.${appName}`} />
          </span>
        </MenuItem>
      );
    });

  return (
    <NavDropdown
      id="apps-navigation-dropdown"
      className="apps-menu"
      title={
        <div className="lcm-iot-icon-apps icon intro-health-022019-step-6" />
      }
    >
      {applicationItems}
    </NavDropdown>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type '({ configuration, location, trac... Remove this comment to see the full error message
export default withConfiguration(withTracking(NavigationAppSwitcher));
